import { render, staticRenderFns } from "./RejectedMenber.vue?vue&type=template&id=1e20f36c&scoped=true"
import script from "./RejectedMenber.vue?vue&type=script&lang=js"
export * from "./RejectedMenber.vue?vue&type=script&lang=js"
import style0 from "./RejectedMenber.vue?vue&type=style&index=0&id=1e20f36c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e20f36c",
  null
  
)

export default component.exports